import React, { FC, useEffect, useState } from "react";

import { useSelector } from "react-redux";
import { MdOutlineEdit } from "react-icons/md";
import { IoDocumentOutline } from "react-icons/io5";


interface InformationProps {
  leadToBeUpdate: string;
  leadData: any; // ← ADD this prop
 
}

const Information: FC<InformationProps> = ({ leadToBeUpdate, leadData: passedLeadData }) => {
  const stateData = useSelector((state: any) => state?.rootReducers);
  const [leadData, setLeadData] = useState<Record<string, any>>({});
  const [customFields, setCustomFields] = useState<Record<string, any>>({});

 

useEffect(() => {
  console.log('📊 Information useEffect - hasData:', !!passedLeadData);
  if (passedLeadData && Object.keys(passedLeadData).length > 0) {
    processLeadData(passedLeadData);
  }
}, [passedLeadData]);

const processLeadData = (leadData: any) => {
  try {
    console.log('🔄 Processing lead data in Information');
    const extraDetails = leadData.extraDetails || {};
    const processedCustomFields = processExtraDetails(extraDetails);
    setCustomFields(processedCustomFields);
  } catch (error) {
    console.error("Error processing lead data:", error);
    setCustomFields({});
  }
};

const processExtraDetails = (details: Record<string, any>): Record<string, any> => {
  const processed: Record<string, any> = {};
  
  try {
    Object.entries(details).forEach(([key, value]) => {
      // Skip null/undefined keys
      if (!key) return;

      try {
        const formattedKey = key
          .replace(/_/g, " ")
          .replace(/\?$/, "")
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");

        // Handle field_data array specially
        if (key === "field_data" && Array.isArray(value)) {
          value.forEach((field: any) => {
            if (field?.label && field?.value !== undefined) {
              processed[field.label] = field.value;
            }
          });
        } 
        // Handle whatsappMessage specially
        else if (key === "whatsappMessage" && typeof value === "object" && value?.body) {
          processed["WhatsappMessage"] = value.body;
        }
        // Handle other objects
        // Handle other objects
else if (typeof value === "object" && value !== null) {
  // Try to extract meaningful content from objects
  if (value.body) {
    processed[formattedKey] = value.body;
  } else if (value.message) {
    processed[formattedKey] = value.message;
  } else if (value.text) {
    processed[formattedKey] = value.text;
  } else {
    // For complex objects like install_referrer, create a formatted display
    const objectEntries = Object.entries(value);
    if (objectEntries.length > 0) {
      // Create a readable multi-line string
      const formattedObject = objectEntries
        .map(([k, v]) => `${k}: ${v}`)
        .join('\n');
      processed[formattedKey] = formattedObject;
    } else {
      processed[formattedKey] = JSON.stringify(value, null, 2);
    }
  }
}
       else if (value !== null && value !== undefined && value !== "") {
  // Handle empty arrays with a friendly message
  if (Array.isArray(value) && value.length === 0) {
    processed[formattedKey] = "No data available";
  } else {
    processed[formattedKey] = value;
  }
}
      } catch (fieldError) {
        console.warn(`Error processing field ${key}:`, fieldError);
      }
    });
  } catch (error) {
    console.error("Error processing extra details:", error);
  }
  
  return processed;
};

  const formatValue = (value: any): string | React.ReactNode => {
    const MAX_LENGTH = 200;

    try {
      // Handle null/undefined
      if (value === null || value === undefined) return "-";

      // Handle arrays
      if (Array.isArray(value)) {
        if (value.length === 0) return "-";
        
        // Check if array contains objects
        if (value.some(item => typeof item === "object" && item !== null)) {
          try {
            return (
              <pre
                style={{
                  background: "#f9f9f9",
                  padding: "8px",
                  borderRadius: "6px",
                  maxHeight: "150px",
                  overflow: "auto",
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  maxWidth: "100%",
                }}
              >
                {JSON.stringify(value, null, 2)}
              </pre>
            );
          } catch (error) {
            console.error("Error stringifying array of objects:", error);
            return "-";
          }
        }

        // Regular array of primitives
        return (
          <ul style={{ paddingLeft: "20px", wordWrap: "break-word" }}>
            {value.map((item, idx) => (
              <li key={idx} style={{ marginBottom: "4px", wordWrap: "break-word" }}>
                {String(item)}
              </li>
            ))}
          </ul>
        );
      }

      // Handle objects
      if (typeof value === "object" && value !== null) {
        try {
          return (
            <pre
              style={{
                background: "#f9f9f9",
                padding: "8px",
                borderRadius: "6px",
                maxHeight: "150px",
                overflow: "auto",
                whiteSpace: "pre-wrap",
                wordWrap: "break-word",
                maxWidth: "100%",
              }}
            >
              {JSON.stringify(value, null, 2)}
            </pre>
          );
        } catch (error) {
          console.error("Error stringifying object:", error);
          return "-";
        }
      }

      // Handle boolean
      if (typeof value === "boolean") return value ? "Yes" : "No";

      // Handle numbers
      if (typeof value === "number") return value.toLocaleString();

      // Handle strings
      if (typeof value === "string") {
        if (value.length > MAX_LENGTH) {
          return <ExpandableText text={value} maxLength={MAX_LENGTH} />;
        }

        if (value.startsWith("http") || value.startsWith("www")) {
          return (
            <a
              href={value}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#1a73e8", wordWrap: "break-word" }}
            >
              {value}
            </a>
          );
        }

        return value || "-";
      }

      // Fallback for any other type
      return String(value) || "-";

    } catch (error) {
      console.error("Error in formatValue:", error);
      return "-";
    }
  };

  const EmptyState: FC<{ message: string }> = ({ message }) => (
    <div style={{ textAlign: "center", padding: "20px", color: "#6b7280" }}>
      <IoDocumentOutline size={40} style={{ marginBottom: "8px", color: "#9ca3af" }} />
      <p style={{ fontSize: "14px", fontWeight: 500 }}>{message}</p>
    </div>
  );

  const ExpandableText: FC<{ text: string; maxLength: number }> = ({ text, maxLength }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    return (
      <div>
        {isExpanded ? text : `${text.slice(0, maxLength)}...`}
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          style={{
            background: "none",
            border: "none",
            color: "#1a73e8",
            cursor: "pointer",
            padding: "0",
            marginLeft: "8px",
            fontSize: "14px",
          }}
        >
          {isExpanded ? "Show Less" : "See More"}
        </button>
      </div>
    );
  };

 return (
  <div className="information-container p-3">
    {/* Leadform Fields Section */}
    <div className="mb-4">
      <h4 className="h5 mb-3 pb-2 border-bottom">Leadform Fields</h4>
      
      {/* WhatsApp Message */}
      {passedLeadData?.extraDetails?.whatsappMessage?.body && (
        <div className="card mb-3">
          <div className="card-body">
            <h6 className="card-subtitle mb-2 text-muted">WhatsappMessage</h6>
            <div className="p-3 bg-light rounded">
              <pre className="mb-0 text-wrap" style={{
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                fontSize: "0.875rem",
                fontFamily: "inherit"
              }}>
                {passedLeadData.extraDetails.whatsappMessage.body}
              </pre>
            </div>
          </div>
        </div>
      )}
    </div>

    {/* General Information Section */}
    <div>
      <h4 className="h5 mb-3 pb-2 border-bottom">General Information</h4>

      {/* Check if we have any basic info to display */}
      {(passedLeadData?.phone || passedLeadData?.email || passedLeadData?.website || passedLeadData?.address || Object.keys(customFields).length > 0) ? (
        <div className="row g-3">
          
          {/* Phone */}
          {passedLeadData?.phone && (
            <div className="col-12">
              <div className="d-flex align-items-center p-3 bg-light rounded">
                <i className="fas fa-phone me-3 text-muted"></i>
                <div>
                  <small className="text-muted d-block">Phone</small>
                  <span className="fw-medium">{passedLeadData.phone}</span>
                </div>
              </div>
            </div>
          )}

          {/* Email */}
          {passedLeadData?.email && (
            <div className="col-12">
              <div className="d-flex align-items-center p-3 bg-light rounded">
                <i className="fas fa-envelope me-3 text-muted"></i>
                <div>
                  <small className="text-muted d-block">Email</small>
                  <span className="fw-medium">{passedLeadData.email}</span>
                </div>
              </div>
            </div>
          )}

          {/* Website */}
          {passedLeadData?.website && (
            <div className="col-12">
              <div className="d-flex align-items-center p-3 bg-light rounded">
                <i className="fas fa-globe me-3 text-muted"></i>
                <div>
                  <small className="text-muted d-block">Website</small>
                  <span className="fw-medium">{passedLeadData.website}</span>
                </div>
              </div>
            </div>
          )}

          {/* Address */}
          {passedLeadData?.address && (
            <div className="col-12">
              <div className="d-flex align-items-center p-3 bg-light rounded">
                <i className="fas fa-map-marker-alt me-3 text-muted"></i>
                <div>
                  <small className="text-muted d-block">Address</small>
                  <span className="fw-medium">{passedLeadData.address}</span>
                </div>
              </div>
            </div>
          )}

          {/* Custom Fields */}
          {Object.keys(customFields).length > 0 && (
            <div className="col-12">
              <h6 className="mt-3 mb-2">Additional Information</h6>
             {Object.entries(customFields).map(([key, value]) => (
  <div key={key} className="p-2 border-bottom">
    <small className="text-muted fw-medium d-block mb-1">{key}:</small>
    <small className="text-dark" style={{
      whiteSpace: "pre-wrap",
      wordBreak: "break-word",
      lineHeight: "1.4"
    }}>
      {String(value)}
    </small>
  </div>
))}
            </div>
          )}
        </div>
      ) : (
        /* No Data State */
        <div className="text-center py-5">
          <i className="fas fa-file-alt fa-3x text-muted mb-3 opacity-50"></i>
          <p className="text-muted mb-0">
            {!passedLeadData ? "Loading lead information..." : "No General Information Available"}
          </p>
        </div>
      )}
    </div>
  </div>
);
};

export default Information;